import React, { FormEvent, useState } from 'react';
import { AuthenticateAdminAsync, setAttemptingLogin } from './authSlice';
import { useAppDispatch } from '../../app/hooks';
import { Box, Button, Container, Paper, Stack, TextField, Typography } from '@mui/material';

const AdminLogin = () => {
  const dispatch = useAppDispatch();
  const [username, setUsername] = useState<string>('');
  const [password, setPassword] = useState<string>('');

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    dispatch(setAttemptingLogin(true));
    const data = { username, password, access: '', refresh: '' };
    dispatch(AuthenticateAdminAsync(data));
    setUsername('');
    setPassword('');
  };
  return (
    <Box>
      <Container maxWidth="sm" sx={{ marginTop: 2 }}>
        <form onSubmit={handleSubmit}>
          <Paper elevation={5}>
            <Stack spacing={2} padding={2}>
              <Typography variant="h4" align="center">
                Admin Login
              </Typography>
              <TextField
                fullWidth
                label="username"
                value={username}
                onChange={({ target }) => setUsername(target.value)}
              />
              <TextField
                fullWidth
                label="password"
                type="password"
                value={password}
                onChange={({ target }) => setPassword(target.value)}
              />
              <Button type="submit" variant="contained">
                Submit
              </Button>
            </Stack>
          </Paper>
        </form>
      </Container>
    </Box>
  );
};

export default AdminLogin;
